import { render, staticRenderFns } from "./FinishCreatePathoService.vue?vue&type=template&id=a8cab5f8"
import script from "./FinishCreatePathoService.vue?vue&type=script&lang=js"
export * from "./FinishCreatePathoService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports